<div class="step-container">
  <h2 class="step-title">Foto del DNI - Frente</h2>
  <p class="step-subtitle">Posicione el frente de su DNI dentro del recuadro y capture la foto.</p>

  <!-- Camera view -->
  <div *ngIf="showWebcam && !cameraError" class="camera-container">
    <div class="webcam-wrapper">
      <webcam
        [trigger]="triggerObservable"
        (imageCapture)="onImageCaptured($event)"
        (initError)="onCameraInit($event)"
        [videoOptions]="videoOptions"
        [imageQuality]="1"
        [switchCamera]="nextWebcamObservable">
      </webcam>
      <div class="webcam-overlay"></div>
    </div>
    <button mat-fab color="primary" class="capture-button" (click)="capture()">
      <mat-icon>circle</mat-icon>
    </button>
  </div>

  <!-- Camera error -->
  <div *ngIf="cameraError" class="camera-error">
    <mat-icon class="error-icon">videocam_off</mat-icon>
    <p>{{ cameraErrorMessage }}</p>
  </div>

  <!-- Preview captured image -->
  <div *ngIf="!showWebcam && capturedImage" class="preview-container">
    <img [src]="capturedImage.imageAsDataUrl" alt="DNI Frente" class="preview-image" />
    <div class="preview-actions">
      <button mat-stroked-button (click)="retake()">
        <mat-icon>refresh</mat-icon>
        Reintentar
      </button>
      <button mat-raised-button color="primary" (click)="confirmCapture()">
        <mat-icon>check</mat-icon>
        Confirmar
      </button>
    </div>
  </div>

  <!-- Upload from gallery -->
  <div class="gallery-option">
    <button mat-stroked-button class="gallery-button" (click)="openGallery()">
      <mat-icon>photo_library</mat-icon>
      Subir desde galería
    </button>
    <input
      #fileInput
      type="file"
      accept="image/*"
      hidden
      (change)="onFileSelected($event)" />
  </div>
</div>
